import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/landing')({
  component: LandingRouteComponent,
});

function LandingRouteComponent() {
  return <Navigate to="/" replace />;
}
